import axios, { AxiosResponse } from 'axios';
import { AxiosRequestConfig } from "axios/index";
import { toast } from 'react-toastify';
import { CODES } from "../constants";
import { S4PResp, S4PRespBody } from "./types";
import Loader from '../components/Loading/index'
import { globalIntl } from '../containers/App/App'

let HOST = ''
//let HOST = 'http://47.74.223.118:8081'

if (process.env.NODE_ENV === 'production') {
  HOST = ''
}

export default (uri: string, params: any): Promise<S4PRespBody> => {
  let config: AxiosRequestConfig = {
    baseURL: HOST,
    headers: {
      Accept: 'application/json',
      location: uri,
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Requested-With': 'H5-Qilinjinfu',
      'X-Client-Version': '1.0',
      'Time-Zone': String(0 - (new Date().getTimezoneOffset() / 60))
    },
    withCredentials: true
  }
  let _params = {
    body: params,
    sign: ''
  }

  let closeLoader = Loader.open({ content: globalIntl.formatMessage({ id: 'loading' }) })
  return axios.post(uri, _params, config)
    .then(function (response: AxiosResponse<S4PResp>) {
      if (response.data.body.code !== CODES.SUCCESS) {
        if (response.data.body.code === CODES.NOT_LOGIN) {
          window.location.href = '/#/login'
        } else {
          toast.error(response.data.body.msg);
        }
      }
      return response.data.body

    })
    .catch(function (error) {
      toast.error(globalIntl.formatMessage({ id: 'SYSTEM_ERROR' }));
      return {
        code: CODES.SYS_ERROR,
        msg: error
      }
    }).finally(() => {
      closeLoader()
    });
}